const DEFAULT_HEIGHT = 90;

const stickyStyle = (isSticky) => (isSticky && {
  position: 'fixed', top: 0
})

const createMenuStyle = (props) => ({
  height: props.height || DEFAULT_HEIGHT,
  ...stickyStyle(props.sticky),
  overflow: 'hidden',
  display: 'flex',
  justifyContent: 'flex-start',
  width: '100%',
  ...props.style
})

const Menu = ({logo, sticky, children, className, rightSideMenu, style, toggleDrawer}) => 
  <div className={className} style={createMenuStyle({logo, sticky, style})}>
    <ul id="navToggle" className="burger drawer" onClick={toggleDrawer}>
      <li></li>
      <li></li>
      <li></li>
    </ul>
    <div className="py-2 xl-menu-logo">
      <a href={logo.link}>
        <img className="mh-100" src={logo.src}></img>
      </a>
    </div>
    <div className="d-flex h-100 nav-bar" style={{alignItems:'center', justifyContent:'space-between'}}>
      {children}
    </div>
    {rightSideMenu && <div style={{minWidth: 120, display:'flex', alignItems:'center', justifyContent:'flex-end', marginLeft: 'auto'}}>{rightSideMenu}</div>}
  </div>;

export default Menu;